import { useEffect, useLayoutEffect, useState } from "react";
import SvgWrappableText from "../../preview/SvgWrappableText";
import pxFromCm from "../../util/pxFromCm";

interface BrochureHeaderProps {
  bigHeader: string;
  subheader: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

export const BrochureHeader: React.FC<BrochureHeaderProps> = ({
  bigHeader, subheader, x, y, width, height
}) => {
  const [mainTextHeight, setMainTextHeight] = useState(0);
  const [mainTextBoxes, setMainTextBoxes] = useState([]);
  const [subtextHeight, setSubtextHeight] = useState(0);
  const [subtextBoxes, setSubtextBoxes] = useState([]);
  const [gap, setGap] = useState(0);
  const [recursion, setRecursion] = useState(0);
  const [fontSize, setFontSize] = useState(260);

  const topMargin = 0.25 * gap;
  const bottomMargin = 0.125 * gap;

  const usedHeight = mainTextHeight + subtextHeight + gap + topMargin + bottomMargin;

  const mainTextTop = y + topMargin + 0.5 * (height - usedHeight);
  const subtextTop = mainTextTop + mainTextHeight + gap;

  const handleMainTextLayout = (h, boxes) => {
    setMainTextHeight(h);
    setMainTextBoxes(boxes);
  }

  const handleSubtextLayout = (h, boxes) => {
    setSubtextHeight(h);
    setSubtextBoxes(boxes);
  }

  useLayoutEffect(() => {
    if (!subheader) {
      setSubtextHeight(0);
    }
    setRecursion(0);
    setFontSize((prev) => {
      if (prev === 260) {
        return 255;
      }
      return 260;
    });
  }, [subheader, bigHeader])

  useLayoutEffect(() => {
    if (!subheader) {
      setGap(0);
    }
    setGap(fontSize * 0.2);
  }, [fontSize]);

  useEffect(() => {
    if (recursion >= 20) {
      return;
    }
    if (usedHeight > height
      || (mainTextBoxes && mainTextBoxes.reduce((acc, b) => Math.max(acc, b.width), 0) > width)
      || (subtextBoxes && subtextBoxes.reduce((acc, b) => Math.max(acc, b.width), 0) > width)
    ) {
      setTimeout(() => {
        setFontSize(fontSize - 10);
        setRecursion(recursion + 1);  
      }, 5);
    }
  }, [mainTextHeight, subtextHeight, gap]);

  return (<g>
    {false && <rect 
      x={x}
      y={y}
      width={width}
      height={height}
      fill="none"
      stroke="black"
      strokeWidth={5}
    />}
    <SvgWrappableText
      text={bigHeader}
      color={"#002A80"}
      x={x + 0.5 * width}
      top={mainTextTop}
      width={width}
      fontSize={fontSize}
      fontWeight="700"
      textAnchor="middle"
      onLayout={handleMainTextLayout}
    />
    {subheader && <SvgWrappableText 
      text={subheader}
      color={"#002A80"}
      x={x + 0.5 * width}
      top={subtextTop}
      width={width - pxFromCm(1.8)}
      fontSize={fontSize * 0.4}
      fontWeight="700"
      textAnchor="middle"
      onLayout={handleSubtextLayout}
    />}
  </g>)
}
